import { render, staticRenderFns } from "./LogsPage.vue?vue&type=template&id=a00c633e&scoped=true&"
import script from "./LogsPage.vue?vue&type=script&lang=js&"
export * from "./LogsPage.vue?vue&type=script&lang=js&"
import style0 from "./LogsPage.vue?vue&type=style&index=0&id=a00c633e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c633e",
  null
  
)

export default component.exports